import { lazy } from 'react';

export default {
  exact: false,
  name: 'Login in with qr-code',
  protected: false,
  path: '/scan',
  component: lazy(() => import('containers/qrLogin')),
};
